<template>
  <div class="flex flex-row flex-wrap w-full">
    <Field
      name="establishmentNumber"
      v-slot="{ field, errors: errs }"
      :rules="
        async (values) =>
          await checkRules(values, [
            {
              name: 'max_char',
              value: 10,
              message: 'INVALID_MAX_CHAR'
            }
          ])
      "
    >
      <SimpleTextInput
        :field="field"
        :errors="errs"
        :label="$t('establishmentNumber')"
        :maxLength="100"
        direction="flex-col"
        :isRequired="false"
        class="lg:w-1/2 flex-col px-2 w-full"
        mask="numberOnly"
        :isDisabled="checkIsDisable(['establishmentNumber'])"
        @onChange="(e) => handleInput(e, 'establishmentNumber')"
      />
    </Field>

    <Field
      name="establishmentArabicName"
      v-slot="{ field, errors: errs }"
      :rules="
        async (values) =>
          await checkRules(values, [
            {
              name: 'max_char',
              value: 10,
              message: 'INVALID_MAX_CHAR'
            },
            {
              name: 'arabicText',
              message: 'ArabicContentOnly'
            }
          ])
      "
    >
      <SimpleTextInput
        :field="field"
        :errors="errs"
        :label="$t('establishmentArabicName')"
        :maxLength="100"
        direction="flex-col"
        :isRequired="false"
        class="lg:w-1/2 flex-col px-2 w-full"
        :isDisabled="checkIsDisable(['establishmentArabicName'])"
        @onChange="(e) => handleInput(e, 'establishmentArabicName')"
      />
    </Field>

    <Field
      name="establishmentEnglishName"
      v-slot="{ field, errors: errs }"
      :rules="
        async (values) =>
          await checkRules(values, [
            {
              name: 'max_char',
              value: 100,
              message: 'INVALID_MAX_CHAR'
            },
            {
              name: 'englishText',
              message: 'EnglishContentOnly'
            }
          ])
      "
    >
      <SimpleTextInput
        :field="field"
        :errors="errs"
        :label="$t('establishmentEnglishName')"
        :maxLength="100"
        direction="flex-col"
        :isRequired="false"
        class="lg:w-1/2 flex-col px-2 w-full"
        :isDisabled="checkIsDisable(['establishmentEnglishName'])"
        @onChange="(e) => handleInput(e, 'establishmentEnglishName')"
      />
    </Field>
    <template v-if="panelType == 'FreeZone'">
      <Field
        name="requestNumber"
        v-slot="{ field, errors: errs }"
        :rules="
          async (values) =>
            await checkRules(values, [
              {
                name: 'min_char',
                value: 25,
                message: 'INVALID_MIN_CHAR'
              }
            ])
        "
      >
        <SimpleTextInput
          :field="field"
          :errors="errs"
          :label="$t('requestNumber')"
          :maxLength="100"
          direction="flex-col"
          :isRequired="false"
          class="lg:w-1/2 flex-col px-2 w-full"
          mask="numberOnly"
          :isDisabled="checkIsDisable(['requestNumber'])"
          @onChange="(e) => handleInput(e, 'requestNumber')"
        />
      </Field>

      <div class="w-full md:w-1/2">
        <label for="EstablishmentCardNumber" class="ms-2 text-brand-black-secondary">
          {{ $t('EstablishmentCardNumber') }}
        </label>
        <div class="w-full" v-if="isDubai">
          <label for="TwoFields" class="m-2">
            {{ $t('twoFields') }}
          </label>
          <input
            name="TwoFields"
            type="radio"
            value="1"
            @change="changeFileFieldsLen(1)"
            :checked="!showThreeFields"
          />
          <label for="ThreeFields" class="m-2">
            {{ $t('ThreeFields') }}
          </label>
          <input
            name="ThreeFields"
            type="radio"
            value="2"
            @change="changeFileFieldsLen(2)"
            :checked="showThreeFields"
          />
        </div>
        <div class="flex gap-x-2">
          <Field
            name="establishmentNumberOfCard"
            v-slot="{ field, errors: errs }"
            :rules="
              async (values) =>
                await checkRules(values, [
                  {
                    name: 'max_char',
                    value: 10,
                    message: 'INVALID_MAX_CHAR'
                  }
                ])
            "
          >
            <SimpleTextInput
              :field="field"
              :errors="errs"
              placeholder="establishmentCardNumber"
              input-class="px-3 py-1.5"
              class="lg:w-1/2 flex-col px-2 w-full"
              direction="flex-col"
              :isRequired="false"
              mask="numberOnly"
              :isDisabled="
                checkIsDisable([
                  'establishmentNumberOfCard',
                  'establishmentType',
                  'establishmentSponsorType'
                ])
              "
              @onChange="(e) => handleInput(e, 'establishmentNumberOfCard')"
            />
          </Field>
          <Field
            name="establishmentSponsorType"
            v-slot="{ field, errors: errs }"
            :rules="
              async (values) =>
                await checkRules(values, [
                  {
                    name: 'max_char',
                    value: 10,
                    message: 'INVALID_MAX_CHAR'
                  }
                ])
            "
          >
            <SimpleTextInput
              :field="field"
              :errors="errs"
              placeholder="establishmentSponsorType"
              input-class="px-3 py-1.5"
              class="lg:w-1/2 flex-col px-2 w-full"
              direction="flex-col"
              mask="##"
              :isRequired="false"
              :isDisabled="
                checkIsDisable([
                  'establishmentNumberOfCard',
                  'establishmentType',
                  'establishmentSponsorType'
                ])
              "
              @onChange="(e) => handleInput(e, 'establishmentSponsorType')"
            />
          </Field>
          <Field
            v-if="showThreeFields"
            name="establishmentType"
            v-slot="{ field, errors: errs }"
            :rules="
              async (values) =>
                await checkRules(values, [
                  {
                    name: 'max_char',
                    value: 10,
                    message: 'INVALID_MAX_CHAR'
                  }
                ])
            "
          >
            <SimpleTextInput
              :field="field"
              :errors="errs"
              placeholder="establishmentType"
              input-class="px-3 py-1.5"
              class="lg:w-1/2 flex-col px-2 w-full"
              direction="flex-col"
              mask="##"
              :isRequired="false"
              :isDisabled="
                checkIsDisable([
                  'establishmentNumberOfCard',
                  'establishmentType',
                  'establishmentSponsorType'
                ])
              "
              @onChange="(e) => handleInput(e, 'establishmentType')"
            />
          </Field>
        </div>
      </div>
    </template>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { Field } from 'vee-validate'
import { useRoute } from 'vue-router'

import SimpleDatepicker from '@/components/SimpleForm/Datepicker.vue'
import SimpleTextInput from '@/components/SimpleForm/TextInput.vue'
import apiHelperService from '@/services'
import client_lookup from '@/assets/json/clientLookups.json'
import useRuleHandler from '@/composables/useRuleHandler'

const showThreeFields = ref(false)
const isDubai = ref(false)
const isDisabledKey = ref('')
const panelType = ref()
const route = useRoute()

const props = defineProps({
  initialValues: Object,
  isShowFingerprintCheckbox: {
    type: Boolean,
    default: false
  },
  values: Object
})
// Find which is currently filled filed.
const checkIsDisable = (keys) => {
  if (!isDisabledKey.value) {
    return false
  } else {
    return !keys.includes(isDisabledKey.value)
  }
}

const handleInput = (e, key) => {
  const excludeKeys = ['pageSize', 'currentPage']
  let hasValue = ''
  Object.entries(props.values).map(([k, v]) => {
    if (v && !excludeKeys.includes(k)) {
      hasValue = k
    }
  })
  isDisabledKey.value = hasValue
}

const checkRules = async (values, rules) => {
  const res = await useRuleHandler(values, rules)
  return res
}

const changeFileFieldsLen = (length) => {
  showThreeFields.value = length == 1 ? false : true
}

const getIsDubai = async () => {
  const res = await apiHelperService.get('/api/establishment/establishment')
  isDubai.value = res?.departmentId == client_lookup.mainDepartments.dubai
}

const checkIsCancelOrFreeZone = () => {
  const isCancel = route.fullPath.indexOf('CanceledChildEstablishments') >= 0
  if (isCancel) {
    panelType.value = 'Cancel'
  } else {
    panelType.value = 'FreeZone'
  }
}
onMounted(() => {
  checkIsCancelOrFreeZone()
  getIsDubai()
})
</script>
